import { render, staticRenderFns } from "./sticky-header.vue?vue&type=template&id=34f1603f&scoped=true&"
import script from "./sticky-header.vue?vue&type=script&lang=js&"
export * from "./sticky-header.vue?vue&type=script&lang=js&"
import style0 from "./sticky-header.vue?vue&type=style&index=0&id=34f1603f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34f1603f",
  null
  
)

export default component.exports